import { useState } from 'react';
import './Experience.css';

const experiences = [
  {
    id: 0,
    role: 'Junior Frontend Developer',
    company: 'Inspiring Lab',
    location: 'Khumaltar, Lalitpur',
    period: 'Dec 2024 – Present',
    type: 'Full-time',
    points: [
      'Develop and build responsive user interfaces for production applications',
      'Implement UI form designs and integrate RESTful APIs seamlessly',
      'Debug and fix UI issues to continuously improve user experience',
      'Collaborate closely with backend and UI/UX teams in agile sprints',
      'Implemented CRUD operations for dynamic data management workflows',
    ],
  },
  {
    id: 1,
    role: 'Frontend Developer Intern',
    company: 'Inspiring Lab',
    location: 'Khumaltar, Lalitpur',
    period: 'April 2024 – Nov 2024',
    type: 'Internship',
    points: [
      'Learned and applied fundamentals of modern frontend development',
      'Worked on assigned tasks under mentor guidance with increasing ownership',
      'Gained hands-on experience with basic UI development and API integration',
      'Transitioned to full-time role based on performance and contribution',
    ],
  },
  {
    id: 2,
    role: 'PHP Developer Intern',
    company: 'Easy Access Pvt. Ltd',
    location: 'Tinkune, Kathmandu',
    period: 'Feb 2023 – Mar 2023',
    type: 'Internship',
    points: [
      'Learned the basics of backend development using PHP',
      'Assisted in simple coding and debugging tasks under guidance',
      'Observed how APIs connect frontend and backend systems in real projects',
    ],
  },
];

export default function Experience() {
  const [active, setActive] = useState(0);
  const exp = experiences[active];

  return (
    <section className="experience section" id="experience">
      <div className="container">
        <div className="section-label">
          <span className="label-line" />
          <span>Experience</span>
        </div>

        <h2 className="section-title">Where I've worked</h2>

        <div className="exp-layout">
          <div className="exp-tabs">
            {experiences.map((e) => (
              <button
                key={e.id}
                className={`exp-tab ${active === e.id ? 'active' : ''}`}
                onClick={() => setActive(e.id)}
              >
                <span className="tab-company">{e.company}</span>
                <span className="tab-period">{e.period}</span>
              </button>
            ))}
          </div>

          <div className="exp-detail" key={active}>
            <div className="exp-header">
              <div>
                <h3 className="exp-role">{exp.role}</h3>
                <div className="exp-meta">
                  <span className="exp-company">{exp.company}</span>
                  <span className="exp-sep">·</span>
                  <span className="exp-loc">{exp.location}</span>
                </div>
              </div>
              <div className="exp-right">
                <span className="exp-badge">{exp.type}</span>
                <span className="exp-period">{exp.period}</span>
              </div>
            </div>
            <ul className="exp-points">
              {exp.points.map((p, i) => (
                <li key={i} style={{ animationDelay: `${i * 80}ms` }}>
                  <span className="point-arrow">→</span>
                  {p}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
